<p-panel
  [header]="'WEB_RESULTS.EPIDEMIOLOGY.PANEL_TITLE' | translate"
  [toggleable]="true"
  [collapsed]="true"
  iconPos="start"
  expandIcon="pi pi-chevron-down"
  collapseIcon="pi pi-chevron-right"
  styleClass="epidemiology-search-panel"
>
  <section class="epidemiology-criteria" [attr.aria-label]="'WEB_RESULTS.EPIDEMIOLOGY.PANEL_TITLE' | translate">
    <p-message *ngIf="panelMessage" severity="info" [text]="panelMessage"></p-message>

    <div class="epidemiology-date-group">
      <label class="epidemiology-label" for="epi-date-from">{{ 'WEB_RESULTS.EPIDEMIOLOGY.DATE_FROM' | translate }}</label>
      <p-calendar
        inputId="epi-date-from"
        [(ngModel)]="dateFrom"
        dateFormat="dd/mm/yy"
        [readonlyInput]="true"
        [firstDayOfWeek]="1"
        [minDate]="minEpidemiologyDate"
        [maxDate]="dateFromMaxDate"
        [showClear]="false"
        [showButtonBar]="true"
        panelStyleClass="epidemiology-datepicker-no-clear"
        appendTo="body"
        (onSelect)="onDateFromChange($event)"
        (ngModelChange)="onDateFromChange($event)"
      ></p-calendar>
    </div>
    <div class="epidemiology-date-group">
      <label class="epidemiology-label" for="epi-date-to">{{ 'WEB_RESULTS.EPIDEMIOLOGY.DATE_TO' | translate }}</label>
      <p-calendar
        inputId="epi-date-to"
        [(ngModel)]="dateTo"
        dateFormat="dd/mm/yy"
        [readonlyInput]="true"
        [firstDayOfWeek]="1"
        [minDate]="dateToMinDate"
        [maxDate]="maxDateTo"
        [showClear]="false"
        [showButtonBar]="true"
        panelStyleClass="epidemiology-datepicker-no-clear"
        appendTo="body"
        (onSelect)="onDateToChange($event)"
        (ngModelChange)="onDateToChange($event)"
      ></p-calendar>
    </div>
    <div class="epidemiology-actions">
      <p-button
        [label]="'WEB_RESULTS.EPIDEMIOLOGY.SEARCH_BUTTON' | translate"
        icon="pi pi-external-link"
        (onClick)="openEpidemiologyView()"
        [disabled]="loading || !patientId || !labNr"
        [attr.aria-label]="'WEB_RESULTS.EPIDEMIOLOGY.SEARCH_BUTTON' | translate"
      ></p-button>
    </div>
  </section>
</p-panel>
